import type { Order } from "@made-people/grease-order";

export const MAX_VISIBLE_THUMBNAILS = 4;

export const getOrderDate = (order: Order) => {
  const d = order.date;
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, "0")}.${String(d.getDate()).padStart(2, "0")}`;
};

export const getOrderTotalQuantity = (order: Order) =>
  order.items.reduce((acc, item) => acc + item.quantity, 0);

export const getOrderItemImages = (order: Order) =>
  order.items
    .map(
      (item) =>
        item.product.base.content.media.find((m) => m.type === "image")?.src,
    )
    .filter((src): src is string => !!src);

export const getProgressStep = (status: string): number => {
  switch (status) {
    case "completed":
      return 2;
    case "cancelled":
    case "refunded":
      return -1;
    default:
      return 0;
  }
};

export const getStatusMessage = (
  status: string,
  translate: (key: string) => string,
): string => {
  switch (status) {
    case "pending":
    case "processing":
      return (
        translate("Account_OrderStatus_Processing_Message") ||
        "Your order is being processed!"
      );
    case "completed":
      return (
        translate("Account_OrderStatus_Completed_Message") ||
        "Your order has been delivered!"
      );
    case "cancelled":
      return (
        translate("Account_OrderStatus_Cancelled_Message") ||
        "Your order has been cancelled"
      );
    case "refunded":
      return (
        translate("Account_OrderStatus_Refunded_Message") ||
        "Your order has been refunded"
      );
    default:
      return translate("Account_OrderStatus_Processing_Message") || "";
  }
};
